import { css } from 'styled-components'

export const ButtonHover = css`
  &:hover {
    background: #505050;
    opacity: 1;
  }
`
